var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.esRoot || _vm.esMtto || _vm.esJefeMtto || _vm.esLecturaMtto)?_c('DashboardMtto'):_vm._e(),(_vm.esRoot || _vm.esActivosFijos || _vm.esLecturaMtto)?_c('DashboardActivos'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }